import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: COLOR_PURPLE,
  },
  textDescription: {
    lineHeight: 1.3,
  },
}));
